<template>
  <form
    ref="form"
    data-url="/accreditationtechnical/revision/action-plan/updateCustom513"
    :class="{ 'loading-opacity': preloader }"
    enctype="multipart/form-data"
  >
    <div class="row">
      <div class="col-12">
        <legend>
          <p class="text-primary">Listado documentos</p>
        </legend>
        <div class="row">
          <div class="col-12">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">NOMBRE</th>
                  <th
                    scope="col"
                    class="align-middle text-center"
                    style="width: 25%"
                  >
                    USUARIO
                  </th>
                  <th scope="col" class="text-center" style="width: 15%">
                    FECHA DE CREACIÓN
                  </th>
                  <th scope="col" class="text-center" style="width: 10%">
                    ACCIÓN
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="accApp && accApp.request_signed">
                  <td class="align-middle">Solicitud de Acreditación</td>
                  <td class="align-middle text-center">
                    {{
                      accApp.request_signed.user
                        ? `${accApp.request_signed.user.first_name} ${accApp.request_signed.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{ accApp.request_signed.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab(accApp, 'request_signed')"
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
                <tr v-if="evalTest && evalTest.file_evaluation">
                  <td class="align-middle">Propuesta del Equipo Evaluador</td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.file_evaluation.user
                        ? `${evalTest.file_evaluation.user.first_name} ${evalTest.file_evaluation.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{ evalTest.file_evaluation_date | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab(evalTest, 'file_evaluation')"
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
                <tr v-if="evalTest && evalTest.sampling_plan_file">
                  <td class="align-middle">Plan de muestreo</td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.sampling_plan_file.user
                        ? `${evalTest.sampling_plan_file.user.first_name} ${evalTest.sampling_plan_file.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{ evalTest.sampling_plan_file_date | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab(evalTest, 'sampling_plan_file')"
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
                <tr v-if="evalTest && evalTest.report_documentary_evaluation">
                  <td class="align-middle">Informe de Evaluación Documental</td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.report_documentary_evaluation.user
                        ? `${evalTest.report_documentary_evaluation.user.first_name} ${evalTest.report_documentary_evaluation.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.report_documentary_evaluation.created_at
                        | dateFormat
                    }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest, 'report_documentary_evaluation')
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
                <tr v-if="evalTest && evalTest.first_instance_finding403">
                  <td class="align-middle">
                    (Evaluación Documental) Primera entrega - Informe para el
                    cierre de hallazgos y decisión
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.first_instance_finding403.user
                        ? `${evalTest.first_instance_finding403.user.first_name} ${evalTest.first_instance_finding403.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.first_instance_finding403.created_at | dateFormat
                    }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest, 'first_instance_finding403')
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
                <tr v-if="evalTest && evalTest.request_additional_evidence">
                  <td class="align-middle">
                    (Evaluación Documental) Solicitud de Evidencias Adicionales
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.request_additional_evidence.user
                        ? `${evalTest.request_additional_evidence.user.first_name} ${evalTest.request_additional_evidence.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.request_additional_evidence.created_at
                        | dateFormat
                    }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest, 'request_additional_evidence')
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
                <tr v-if="evalTest && evalTest.closing_finding_report">
                  <td class="align-middle">
                    (Evaluación Documental) Informe para el cierre de hallazgos
                    y decisión (Evaluador)
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.closing_finding_report.user
                        ? `${evalTest.closing_finding_report.user.first_name} ${evalTest.closing_finding_report.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.closing_finding_report.created_at | dateFormat
                    }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest, 'closing_finding_report')
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
                <tr v-if="evalTest && evalTest.second_instance_finding403">
                  <td class="align-middle">
                    (Evaluación Documental) Segunda entrega - Informe para el
                    cierre de hallazgos y decisión
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.second_instance_finding403.user
                        ? `${evalTest.second_instance_finding403.user.first_name} ${evalTest.second_instance_finding403.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.second_instance_finding403.created_at
                        | dateFormat
                    }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest, 'second_instance_finding403')
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
                <tr v-if="evalTest && evalTest.closing_finding_report_second">
                  <td class="align-middle">
                    (Evaluación Documental) 2do Informe para el cierre de
                    hallazgos y decisión (Evaluador)
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.closing_finding_report_second.user
                        ? `${evalTest.closing_finding_report_second.user.first_name} ${evalTest.closing_finding_report_second.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.closing_finding_report_second.created_at
                        | dateFormat
                    }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest, 'closing_finding_report_second')
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
                <tr v-if="evalTest && evalTest.evaluation_plan_report">
                  <td class="align-middle">
                    (Evaluación InSitu / Remota) Plan de Evaluación
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.evaluation_plan_report.user
                        ? `${evalTest.evaluation_plan_report.user.first_name} ${evalTest.evaluation_plan_report.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.evaluation_plan_report.created_at | dateFormat
                    }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest, 'evaluation_plan_report')
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
                <!-- <tr v-if="evalTest && evalTest.accepted_evaluation_plan">
                    <td class="align-middle">
                      (Evaluación InSitu / Remota) Plan de Evaluación (Aprobado
                      por el OEC)
                    </td>
                    <td class="align-middle text-center">
                      {{
                        evalTest.accepted_evaluation_plan.created_at | dateFormat
                      }}
                    </td>
                    <td class="align-middle text-center">
                      <button
                        type="submit"
                        class="btn btn-success"
                        @click.prevent="
                          openTab(evalTest, 'accepted_evaluation_plan')
                        "
                      >
                        <app-icon name="file" />
                        {{ $t("view") }}
                      </button>
                    </td>
                  </tr> -->
                <tr
                  v-if="evalTest && evalTest.remote_in_situ_assessment_report"
                >
                  <td class="align-middle">
                    (Evaluación InSitu / Remota) Informe de Evaluación InSitu /
                    Remota
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.remote_in_situ_assessment_report.user
                        ? `${evalTest.remote_in_situ_assessment_report.user.first_name} ${evalTest.remote_in_situ_assessment_report.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.remote_in_situ_assessment_report.created_at
                        | dateFormat
                    }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest, 'remote_in_situ_assessment_report')
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
                <tr v-if="evalTest && evalTest.testification_report">
                  <td class="align-middle">Informe de Testificación</td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.testification_report.user
                        ? `${evalTest.testification_report.user.first_name} ${evalTest.testification_report.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{ evalTest.testification_report.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab(evalTest, 'testification_report')"
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
                <tr v-if="evalTest && evalTest.other_record506">
                  <td class="align-middle">Otro</td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.other_record506.user
                        ? `${evalTest.other_record506.user.first_name} ${evalTest.other_record506.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{ evalTest.other_record506.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab(evalTest, 'other_record506')"
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="historical512 && historical512.length > 0">
        <legend class="text-primary">
          <p>Historico de plan de acción</p>
        </legend>
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col" class="align-middle">NOMBRE</th>
              <th
                scope="col"
                class="align-middle text-center"
                style="width: 25%"
              >
                USUARIO
              </th>
              <th
                scope="col"
                class="align-middle text-center"
                style="width: 15%"
              >
                FECHA
              </th>
              <th
                scope="col"
                class="align-middle text-center"
                style="width: 10%"
              ></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(historical, i) in historical512" :key="i">
              <td class="align-middle">Plan de acción - {{ i + 1 }}</td>
              <td class="align-middle text-center">
                {{
                  historical.user
                    ? `${historical.user.first_name} ${historical.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ historical.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTabFile(historical.path)"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-12" v-if="inputs.action_plan">
        <button
          type="button"
          class="btn btn-success"
          @click="openTab(inputs, 'action_plan')"
        >
          <app-icon name="file" />
          Ver Plan de acción
        </button>
      </div>

      <div class="col-sm-12">
        <br />
        <div class="float-left mb-3 mb-3">
          <div class="form-group text-left">
            <label>
              {{
                !historical512 || historical512.length <= 0
                  ? "¿Existen observaciones al plan de acción?"
                  : "¿Existen nuevas observaciones del plan de acción?"
              }}
            </label>
            <app-input
              type="radio-buttons"
              v-model="inputs.is_observations_action_plan"
              :list="confirm"
            />
          </div>
        </div>
      </div>

      <div class="col-sm-12 mt-2" v-if="!inputs.is_observations_action_plan">
        <legend>
          <p class="text-primary">
            Informe Para El Cierre De No Conformidades De OEC Y Para La Decisión
          </p>
        </legend>
      </div>
      <div class="col-sm-6 mt-2" v-if="!inputs.is_observations_action_plan">
        <!-- <legend>
          <p class="text-primary">
            Informe Para El Cierre De No Conformidades De OEC Y Para La Decisión
          </p>
        </legend> -->
          <div class="form-group">
            <label
              >Subir plan de acción con el informe de cierre de no conformidades
              <b class="text-danger ml-2" style="font-size: 18px !important"
                >*</b
              ></label
            >
            <app-input
              type="file"
              :label="inputs.file_2 ? inputs.file_2.name : $t('upload_your_file')"
              v-model="inputs.file_2"
              :required="true"
              v-if="!inputs.report_plan_action"
              v-on:change="fileChoosen($event, 'file_2')"
            />
            <p v-if="!inputs.report_plan_action" class="text-danger mt-2">
              <small>
                <strong
                  >El tamaño maximo permitido para el archivo es de 15MB</strong
                >
              </small>
            </p>
            <div class="mt-2">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(inputs, 'report_plan_action')"
                v-if="inputs.report_plan_action"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>

              <button
                type="submit"
                class="btn btn-danger"
                @click.prevent="openDeleteModal('report_plan_action')"
                v-if="inputs.report_plan_action"
              >
                <app-icon name="trash-2" />
                {{ $t("delete") }}
              </button>
            </div>
          </div>
      </div>

      <div class="col-sm-6 mt-2" v-if="inputs.is_observations_action_plan">
        <legend>
          <p class="text-primary">Observaciones del plan de acción</p>
        </legend>
        <div class="form-group">
          <label
            >Subir plan de acción con observaciones
            <b class="text-danger ml-2" style="font-size: 18px !important"
              >*</b
            ></label
          >
          <app-input
            type="file"
            :label="inputs.file_1 ? inputs.file_1.name : $t('upload_your_file')"
            v-model="inputs.file_1"
            :required="true"
            v-if="!inputs.observation_plan_action"
            v-on:change="fileChoosen($event, 'file_1')"
          />
          <p v-if="!inputs.observation_plan_action" class="text-danger mt-2">
            <small>
              <strong
                >El tamaño maximo permitido para el archivo es de 15MB</strong
              >
            </small>
          </p>
          <div class="mt-2">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs, 'observation_plan_action')"
              v-if="inputs.observation_plan_action"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal('observation_plan_action')"
              v-if="inputs.observation_plan_action"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <hr />
    <div class="alert alert-warning col-12" role="alert">
      Después de <b>Guardar</b> deberá <b>Procesar</b> el registro
    </div>
    <div class="row">
      <div class="col-12 mt-3">
        <button
          type="submit"
          class="btn btn-primary mr-2"
          @click.prevent="submit"
        >
          {{ $t("save") }}
        </button>
        <button
          type="button"
          class="btn btn-success btn-with-shadow ml-3"
          @click="openDeleteModalProccess"
        >
          Procesar
        </button>
      </div>
    </div>

    <app-confirmation-modal
      v-if="deleteModal"
      modal-id="delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea eliminar este archivo?"
    />

    <app-confirmation-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="modal-confirm-id"
      @confirmed="confirmedProccess"
      @cancelled="cancelledProccess"
      title="POR FAVOR ASEGÚRESE DE CARGAR EL FORMATO VIGENTE, QUE LO PUEDE ENCONTRAR  EN LA PARTE SUPERIOR DE ESTA INTERFAZ"
      message="¿Desea procesar este registro?"
      firstButtonName="Aceptar"
      secondButtonName="Cancelar"
      modalClass="success"
      icon="cpu"
    />
  </form>
</template>
  
  <script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { axiosPost } from "@/app/helpers/AxiosHelper";
import * as actions from "../../../apiUrl";
import axios from "axios";

export default {
  mixins: [FormMixin],

  data() {
    return {
      preloader: false,
      inputs: {
        exist_complaint: 0,
        support_management_non_conformities_601_1: [],
        support_management_non_conformities_601_2: [],
        support_management_non_conformities_601_3: [],
      },
      showFileTemplate: false,
      showSecondEvidenceDoc: false,
      path_non_file: "",
      deleteModal: false,
      historical512: [],
      selected: "",
      observation: "",
      files_1: [],
      files_2: [],
      files_3: [],
      list: [
        {
          id: 1,
          value: "SI",
        },
        {
          id: 0,
          value: "NO",
        },
      ],
      confirm: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
      reasonList: [],
      dateComplaint: "",
      section_complaint: false,
      requiredReason: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      showTimeA: true,
    };
  },

  computed: {
    evalTest() {
      return this.$store.state.evaluatorReview.evalTest
        ? this.$store.state.evaluatorReview.evalTest
        : {};
    },

    accApp() {
      return this.evalTest ? this.evalTest.accreditation_applications : null;
    },

    rejectCounter() {
      return this.$store.state.evaluatorReview.evalTest
        ? this.$store.state.evaluatorReview.evalTest
            .corrective_actions_reject_counter == 0
        : true;
    },
  },

  watch: {
    "$store.state.evaluatorReview.evalTest": function () {
      this.loadForm();
    },
  },

  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },

  created() {
    this.openFilesTemplatesCharge();
    this.loadForm();
    // this.openComplaintSection();
  },

  methods: {
    beforeSubmit() {
      this.preloader = true;
      if (this.inputs.exist_complaint) {
        this.requiredReason = true;
      }
    },
    fileChoosen(event, key) {
      const type1 = "application/msword";
      const type2 =
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      if (
        event.target.files[0].type === type1 ||
        event.target.files[0].type === type2
      ) {
        //To do something
      } else {
        this.$toastr.e("Solo se permite archivos de word: .doc, .docx");
        this.inputs[key] = null;
      }
    },
    submit() {
      if (this.inputs.file_1 && this.inputs.file_1.size > 16000000) {
        this.$toastr.e("El tamaño maximo permitido para el archivo es de 15MB");
        return;
      }

      if (this.inputs.file_2 && this.inputs.file_2.size > 16000000) {
        this.$toastr.e("El tamaño maximo permitido para el archivo es de 15MB");
        return;
      }

      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }

      this.save(formData);
    },

    afterSuccess({ data: { data } }) {
      this.$store.state.evaluatorReview.evalTest = data;
      this.$toastr.s(this.$t("updated_success"));
      // this.files_1 = [];
      // this.files_2 = [];
      // this.files_3 = [];
      // this.requiredReason = false;
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    openDeleteModal(fileName) {
      this.selected = fileName;
      this.deleteModal = true;
    },

    confirmed() {
      this.inputs[this.selected] = null;
    },

    observationList() {},

    cancelled() {
      this.deleteModal = false;
    },

    openTab(obj, fileName) {
      let info = {};
      info["accAppId"] = null;
      info["evalTestId"] = this.$store.state.evaluatorReview.evalTest.id;
      info["path"] = String(obj[fileName].path);
      this.$store.dispatch("registerFileLog", info);
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },

    loadForm() {
      if (this.$store.state.evaluatorReview.evalTest) {
        this.inputs = {
          evalTestId: this.$store.state.evaluatorReview.evalTest.id,
          third_instance_finding601:
            this.$store.state.evaluatorReview.evalTest
              .third_instance_finding601,
          second_instance_finding601:
            this.$store.state.evaluatorReview.evalTest
              .second_instance_finding601,
          first_instance_finding601:
            this.$store.state.evaluatorReview.evalTest
              .first_instance_finding601,
          support_management_non_conformities_601_1:
            this.$store.state.evaluatorReview.evalTest
              .support_management_non_conformities_601_1,
          support_management_non_conformities_601_2:
            this.$store.state.evaluatorReview.evalTest
              .support_management_non_conformities_601_2,
          support_management_non_conformities_601_3:
            this.$store.state.evaluatorReview.evalTest
              .support_management_non_conformities_601_3,
          complaint_document_oec:
            this.$store.state.evaluatorReview.evalTest.complaint_document_oec,
          exist_complaint:
            this.$store.state.evaluatorReview.evalTest.exist_complaint,
          reason_complaint_id:
            this.$store.state.evaluatorReview.evalTest.reason_complaint_id,
          extension_time601:
            this.$store.state.evaluatorReview.evalTest.extension_time601,
          extension_601:
            this.$store.state.evaluatorReview.evalTest.extension_601,
          extend_time_601:
            this.$store.state.evaluatorReview.evalTest.extend_time_601,
          action_plan: this.$store.state.evaluatorReview.evalTest.action_plan,
          is_observations_action_plan:
            this.$store.state.evaluatorReview.evalTest
              .is_observations_action_plan,
          observation_plan_action:
            this.$store.state.evaluatorReview.evalTest.observation_plan_action,
          report_plan_action:
            this.$store.state.evaluatorReview.evalTest.report_plan_action,
        };
        this.verifyHistoricals(this.$store.state.evaluatorReview.evalTest.id);
      }
    },

    validateFileSize(files) {
      return files.filter((file) => {
        if (file.size > 15000000) {
          return file;
        }
      }).length;
    },

    openFilesTemplates() {
      const w = window.open(this.path_non_file, "_blank");
      w.focus();
    },

    openFilesTemplatesCharge() {
      // consultar el template activo
      let urlNon = `non-conformities-template/infoActiveTemplate`;
      this.axiosGet(urlNon)
        .then((response) => {
          if (response.data.path != undefined) {
            this.showFileTemplate = true;
            this.path_non_file = response.data.path;
          }
        })
        .catch((error) => {
          console.log(error);
        });
      let reasonUrl = `accreditations/process/nonConformitiesEvaluation/reasonComplaintList`;
      this.axiosGet(reasonUrl).then((response) => {
        this.reasonList = response.data;
      });
    },

    openComplaintSection() {
      var id = localStorage.getItem("evalId");
      let dateUrl = `/accreditations/elaboration/action-plan/no-conformities/validateComplaint/${id}`;
      this.axiosGet(dateUrl).then((response) => {
        this.dateComplaint = response.data;
        if (this.dateComplaint) {
          this.section_complaint = true;
        } else {
          this.section_complaint = false;
        }
      });
    },
    openDeleteModalProccess() {
      this.deleteConfirmationModalActive = true;
    },
    confirmedProccess() {
      this.preloader = true;
      const url = `${actions.REVISION_ACTION_PLAN}/process?evalTestId=${this.$store.state.evaluatorReview.evalTest.id}`;
      const data = {
        additional_evidence: this.additional_evidence,
        corrective_actions_reject_counter:
          this.$store.state.evaluatorReview.evalTest
            .corrective_actions_reject_counter,
      };
      axiosPost(url, data)
        .then(({ data: res }) => {
          this.preloader = false;
          $("#modal-confirm-id").modal("hide");
          this.cancelledProccess();
          if (res.data === "OK") {
            this.$toastr.s("Registro procesado con exito");
            this.returnPage();
          } else {
            this.$toastr.e(res.data);
          }
        })
        .catch(({ error }) => {});
    },
    cancelledProccess() {
      this.deleteConfirmationModalActive = false;
    },
    returnPage() {
      window.location.href = `/accreditationtechnical/revision/action-plan`;
    },
    verifyHistoricals(evalId) {
      axios.get(`/accreditations/historicals/${evalId}`).then((response) => {
        this.historical512 = response.data;
      });
    },
    openTabFile(path) {
      window.open(path, "_blank").focus();
    },
  },
};
</script>
  <style>
.color_import {
  color: #ff5733;
  font-weight: bolder;
}
</style>
  